// Sales Quotes GraphQL queries

import { gql } from "@apollo/client"

export const GET_SALES_QUOTES = gql`
  query GetSalesQuotes($fresh: Boolean) {
    getSalesQuotes(fresh: $fresh) {
      id
      quoteNbr
      businessAccount
      contactContact
      date
      description
      total
      status
      opportunityID
      expirationDate
      note
      contactID
      currency
      location
      ownerID
      ownerContact
      textHeader
      textFooter
    }
  }
`

export const GET_SALES_QUOTE_DETAILS = gql`
  query GetSalesQuoteDetails($quoteID: ID!) {
    getSalesQuoteDetailsByQuoteID(quoteID: $quoteID) {
      id
      quoteID
      lineNbr
      productID
      description
      quantity
      unitPrice
      extPrice
      discountPercent
      discountAmount
    }
  }
`

export const GET_SALES_QUOTE_BY_QUOTE_NBR_WITH_DETAILS = gql`
  query GetSalesQuoteByQuoteNbrWithDetails($quoteNbr: String!) {
    getSalesQuoteByQuoteNbrWithDetails(quoteNbr: $quoteNbr) {
      salesQuote {
        id
        quoteNbr
        businessAccount
        contactContact
        date
        description
        total
        status
        opportunityID
        expirationDate
        note
        contactID
        currency
        location
        ownerID
        ownerContact
        textHeader
        textFooter
      }
      details {
        id
        quoteID
        lineNbr
        productID
        description
        quantity
        unitPrice
        extPrice
        discountPercent
        discountAmount
        akkreditiert
        LIMSguid
        norm
      }
    }
  }
`

// Note: single-ID query removed in favor of batched variant below

export const GET_SALES_QUOTES_BY_OPPORTUNITY_IDS = gql`
  query GetSalesQuotesByOpportunityIDs($opportunityIDs: [String!]!) {
    getSalesQuotesByOpportunityIDs(opportunityIDs: $opportunityIDs) {
      id
      quoteNbr
      businessAccount
      contactContact
      date
      description
      total
      status
      opportunityID
      expirationDate
      note
      contactID
      currency
      location
      ownerID
      ownerContact
      textHeader
      textFooter
      primary
    }
  }
`
